import React, { useEffect, useState } from 'react';
import { useExchange } from '~src/hooks/useExchange';
import InputGroup from './Form/InputGroup';

export function ComboText({ usdValue, coinValue, coinSymbol, loading }) {
  const [tmpUsdValue, setTmpUsdValue] = React.useState(usdValue);
  const [tmpCoinValue, setTmpCoinValue] = React.useState(coinValue);

  let { isLoading, error, getCoinValue, getUsdValue } = useExchange();

  React.useEffect(() => {
    if (!usdValue) {
      let v = getUsdValue(coinSymbol, coinValue);
      setTmpUsdValue(v);
    }
    else {
      setTmpUsdValue(usdValue);
    }

    if (coinValue === null || coinValue === undefined) {
      let v = getCoinValue(coinSymbol, usdValue);
      setTmpCoinValue(v);
    }
    else {
      setTmpCoinValue(coinValue);
    }

  }, [usdValue, coinValue, coinSymbol, getCoinValue, getUsdValue]);

  if (isLoading || loading) {
    return (
      <>
        {coinSymbol} <LoadingValue decimalPlaces={8} />
        ($
        <LoadingValue decimalPlaces={2} />)
      </>
    );
  }

  if (error) {
    return <span>Error!</span>;
  }

  if (!tmpUsdValue || !tmpCoinValue) {
    return null;
  }

  return (
    <>
      {coinSymbol} <span>{parseFloat(tmpCoinValue).toFixed(8)}</span> &nbsp; ($
      <span>{parseFloat(tmpUsdValue).toFixed(2)}</span>)
    </>
  );
}

export function CoinToUsdText({ coinValue, symbol }) {
  let { isLoading, error, getUsdValue } = useExchange();

  if (isLoading) {
    return <LoadingValue decimalPlaces={8} />;
  }

  if (error) {
    return <span>Error!</span>;
  }

  let usdValue = getUsdValue(symbol, coinValue)

  if (usdValue === null) {
    return '--';
  }

  return <span>{usdValue.toFixed(2)}</span>
}

export function UsdToCoinInputGroup({ usdValue, className, selectedCoin = "ETH", onCoinChange = (newCoin) => {} }) {
  let { isLoading, error, getCoinValue } = useExchange();
  const [coinOption, setCoinOption] = useState(selectedCoin);

  useEffect(() => {
    setCoinOption(selectedCoin);
  }, [selectedCoin]);

  const handleCoinChange = (e) => {
    e.preventDefault();
    setCoinOption(e.target.value);
    onCoinChange(e.target.value);
  }

  let tmpClassName = '' + className;

  if (isLoading) {
    tmpClassName += ' throb';
    return (
      <InputGroup
        label={'ETH'}
        name='ethValue'
        disabled={true}
        className={tmpClassName}
        value={''}
      />
    );
  }

  if (error) {
    return <span>Error!</span>;
  }

  const coinValue = getCoinValue(coinOption, usdValue);

  if (coinValue === null) {
    return <span>unknown...</span>;
  }

  return (
    <InputGroup
      label={
        <div className='w-[100px]'>
          <select value={coinOption}
                  className="p-0 pl-1 w-full -my-1 bg-transparent border-0 focus:ring-0"
                  onChange={handleCoinChange}>
            <option value={"ETH"}>ETH</option>
            <option value={"USDC"}>USDC</option>
            <option value={"GIVE"}>GIVE</option>
          </select>
        </div>
      }
      name='coinValue'
      disabled={true}
      className={tmpClassName}
      value={(coinValue).toFixed(8)}
    />
  );
}

export function LoadingValue({ decimalPlaces = 2 }) {
  let decimals = [];
  for (let i = 0; i < decimalPlaces; i++) {
    decimals.push(i);
  }
  return (
    <>
      <span className='crosswind ml-1 py-0 px-2 bg-gradient-to-r from-slate-300 via-slate-100 to-slate-200 rounded-md'>
        &nbsp;
      </span>
      .
      <span className='crosswind mr-1 py-0 px-5 bg-gradient-to-r from-slate-300 via-slate-100 to-slate-200 rounded-md'>
        {decimals.map((decimal) => (
          <span key={decimal}>&nbsp;</span>
        ))}
      </span>
    </>
  );
}
